import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  IconButton,
  Avatar,
  Container,
  Stack,
  styled,
  Divider,
  CircularProgress,
  Menu,
  MenuItem,
  Modal,
  Stepper,
  Button,
  Card, CardContent, CardMedia, Link
} from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import axios from 'axios';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import io from "socket.io-client";
import { getChatsByProjectId } from "../../apis/apiList/chatApi";
import { getUsersByOrgId, getProductionTeam} from "../../apis/apiList/userApi";
import { getSlackInvitationUrl } from "../../apis/apiList/chatApi";
import { useMessage } from "../../context/MessageContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSearchParams } from "react-router-dom";

import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
// import Underline from '@tiptap/extension-underline'
import TiptapLink from '@tiptap/extension-link'
import EmojiPicker from 'emoji-picker-react'
import FormatBoldIcon from '@mui/icons-material/FormatBold'
import FormatItalicIcon from '@mui/icons-material/FormatItalic'
import InsertLinkIcon from '@mui/icons-material/InsertLink'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered'
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Mention from '@tiptap/extension-mention'
import slackIcon from "../../assets/assets-icon/slackIcon.png";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Image from '@tiptap/extension-image'
import docx from '../../assets/assets-icon/docx.png'
import excel from '../../assets/assets-icon/excel.png'
import pdf from '../../assets/assets-icon/pdf.png'
import folder1 from '../../assets/assets-icon/folder1.png'
import zip from '../../assets/assets-icon/zip.png'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { downloadFileFromBox } from "../../apis/apiList/boxAssetsApi";
import socket from "../../services/socket";

// const socket = io( process.env.REACT_APP_BACKEND_URL, {
//   reconnection: true,              // Enable reconnection
//   reconnectionDelay: 1000,         // Delay between attempts
//   reconnectionDelayMax: 5000       // Max delay between attempts
// } );

const ChatContainer = styled(Box)(({ theme }) => ({
  height: "92vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#ffffff",
  borderRadius: "12px",
  overflow: "hidden"
}));

const MessagesArea = styled(Box)({
  flex: 1,
  overflowY: "auto",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "16px"
});

const MessageBubble = styled(Paper)(({ isOwn }) => ({
  padding: "12px 16px",
  maxWidth: "80%",
  width: "fit-content",
  borderRadius: "12px",
  backgroundColor: isOwn ? "#e6f0ff" : "#f5f5f5",
  color: isOwn ? "#ffffff" : "#000000",
  alignSelf: isOwn ? "flex-end" : "flex-start",
  // boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
}));

const InputArea = styled(Box)({
  padding: "20px",
  backgroundColor: "#ffffff",
  borderTop: "1px solid #e0e0e0"
});

const DateDivider = styled(Box)({
  display: "flex",
  alignItems: "center",
  margin: "16px 0",
  width: "100%"
});

const DateLine = styled(Divider)({
  flexGrow: 1
});

const DateLabel = styled(Typography)({
  margin: "0 16px",
  color: "#666",
  fontSize: "0.85rem",
  fontWeight: 500
});

const LoaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  padding: "10px 0"
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


const options = [
  'Connect with Slack',
];
const ITEM_HEIGHT = 48;

export const ProjectChat = ({ project, userDetails, associatedUser }) => {
  const [projectInfo, setProjectInfo] = useState(project);
  const [userInfo, setUserInfo] = useState(userDetails);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);
  const [fetchingOldMsg, setFetchingOldMsg] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openSlackModel, setOpenSlackModel] = useState(false);
  const [isConnectedToSlack, setIsConnectedToSlack] = useState(false);
  // const [mentionQuery, setMentionQuery] = useState("");
  // const [mentionSuggestions, setMentionSuggestions] = useState([]);
  // const [mentionAnchorEl, setMentionAnchorEl] = useState(null);
  // const inputRef = useRef(null);
  const [projectUsers, setProjectUsers] = useState(associatedUser?[...associatedUser, {_id: 1, label: 'all'}]:[]);
  const [mentionQuery, setMentionQuery] = useState("");
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [mentionAnchorEl, setMentionAnchorEl] = useState(null);
  const [mentionedUsers, setMentionedUsers] = useState([]);
  const {showMessage} = useMessage();
  const inputRef = useRef(null);
  const popperRef = useRef(null);
  const [searchParams] = useSearchParams();

  const [showToolbar, setShowToolbar] = useState(true)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [showLinkModal, setShowLinkModal] = useState(false)
  const [linkUrl, setLinkUrl] = useState('')
  const [linkText, setLinkText] = useState('')
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [isSendingMessage, setIsSendingMessage] = useState(false);

  useEffect(() => {
    const isSlackConnected = searchParams.get("slackConnected");
    if (isSlackConnected === "true") {
      showMessage("Slack connected successfully...!!", 'success');
    } else if (isSlackConnected === "false") {
      showMessage("Failed to connect Slack. Please try again.", 'error');
    }
  }, [searchParams]);
  
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isUploadingFile) {
        e.preventDefault();
        e.returnValue = ''; // Required for Chrome
      }
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
  
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isUploadingFile]);

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Enter a valid email address"
        )
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      // console.log(values.email);
      handleUserSlackEmail(values.email);
    },
  });

  const handleUserSlackEmail = async (email)=>{
    try {
      const invitationLink = await getSlackInvitationUrl({email: email}, userInfo._id);
      // console.log('invitationLink', invitationLink);

      if(invitationLink.data.url){
        // window.location.href = invitationLink.data.url
        window.open(invitationLink.data.url, "_blank"); 
        // socket.emit('team_join', {event:{
        //   "type": "team_join",
        //   "user": {
        //     "id": "U023BECGF",
        //     "name": "bobby",
        //     "deleted": false,
        //     "color": "9f69e7",
        //     "profile": {
        //         "first_name": "Bobby",
        //         "last_name": "Tables",
        //         "real_name": "Bobby Tables",
        //         "email": email
        //     },
        //     "is_admin": true,
        //     "is_owner": true,
        //     "is_primary_owner": true,
        //     "is_restricted": false,
        //     "is_ultra_restricted": false,
        //     "has_2fa": false,
        //     "two_factor_type": "sms"
        //   }
        // }, client:{}})
      }
      setOpenSlackModel(false);
    } catch (error) {
      console.log('error', error);
    }
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const messagesAreaRef = useRef(null);
  const messagePageSize = 10;

  useEffect(() => {
    if (userDetails && project) {
      setProjectInfo(project);
      setUserInfo(userDetails);
      socket.emit("joinForRealUpdate", { userId: userDetails._id });
      // setIsConnectedToSlack(userDetails.)
    }
  }, [userDetails, project]);

  // Initial fetch of messages
  useEffect(() => {
    async function fetchInitialMessages() {
      setLoading(true);
      try {
        const response = await getChatsByProjectId(projectInfo._id, 1, messagePageSize);
        // console.log('response chats', response);
        const formattedMessages = response.data.messages.map(formatMessage);
        // console.log('formattedMessages', formattedMessages);
        setMessages(formattedMessages);
        setHasMore(response.data.pagination.hasMore);
        setInitialLoad(true);
      } catch (error) {
        console.error("Error fetching messages:", error);
      } finally {
        setLoading(false);
      }
    }

    async function getOrganizationTeam() {
      // try {
        // const response = await getProductionTeam();
        // const orgUsers = await getUsersByOrgId(projectInfo.orgId);
        // console.log('production team', response);
        // console.log('organization orgUsers', orgUsers);
        // console.log('associatedUser', associatedUser);
        setProjectUsers([...associatedUser, {_id: 1, label: 'all'}]);
      // } catch(error) {
      //   console.log('error', error);
      // }
    }

    // console.log('projectInfo', projectInfo);
    if (projectInfo?._id) {
      socket.emit("joinProject", { projectId: projectInfo._id });
      fetchInitialMessages();
      getOrganizationTeam();

      socket.on("receiveMessage", (message) => {
        console.log('recieved message', message);
        setMessages((prev) => [formatMessage(message), ...prev]);
        setIsSendingMessage(false);
      });
      
      socket.on("receiveWorkspaceJoinNotification", (user) => {
        // console.log('join workspace ', user);
        // setMessages((prev) => [formatMessage(message), ...prev]);
        setUserInfo((prev)=>({
          ...prev,
          slackUserId: user.slackUserId,
          isSlackOauthCompleted:user.isSlackOauthCompleted,
          isSlackWorkspaceJoined:user.isSlackWorkspaceJoined,
          hasSlackAccount: user.hasSlackAccount,
          userSlackEmail: user.userSlackEmail
        }))
      });

      socket.on("errorInMessage", (message) => {
        console.log('error message', message);
        setIsSendingMessage(false);
        showMessage(message, 'error')
      });

      return () => {
        socket.off("receiveMessage");
      };
    }
  }, [projectInfo]);

  // Scroll to bottom on initial load and when new messages are sent/received
  useEffect(() => {
    // console.log('old message')
    if (messagesAreaRef.current && (initialLoad || messages.length > 0)) {
      // console.log('old message if')
      scrollToBottom();
      if (initialLoad) {
        setInitialLoad(false);
      }
    }
  }, [messages, initialLoad]);

  // Add scroll event listener for detecting when user scrolls to top
  useEffect(() => {
    // console.log('loading, hasmore, page')
    const messagesArea = messagesAreaRef.current;
    if (!messagesArea) return;
    
    const handleScroll = () => {
      // console.log('loading, hasmore, page handle scroll')
      // If user scrolls to near the top (within 50px) and we're not already loading
      if (messagesArea.scrollTop < 50 && !loading && hasMore) {
        loadMoreMessages();
      }
    };

    messagesArea.addEventListener('scroll', handleScroll);
    return () => {
      messagesArea.removeEventListener('scroll', handleScroll);
    };
  }, [loading, hasMore, page]);

  // Function to scroll to the bottom of the chat
  const scrollToBottom = () => {
    if(fetchingOldMsg){
      setFetchingOldMsg(false);
    } else {
      if (messagesAreaRef.current) {
        messagesAreaRef.current.scrollTop = messagesAreaRef.current.scrollHeight;
      }
    }
  };

  // Function to load more messages
  const loadMoreMessages = async () => {
    if (!hasMore || loading) return;
    
    setLoading(true);
    // console.log("Loading more messages, page:", page + 1);
    const nextPage = page + 1;
    
    try {
      // Save the current scroll height to maintain position
      const scrollHeightBefore = messagesAreaRef.current?.scrollHeight || 0;
      const scrollTopBefore = messagesAreaRef.current?.scrollTop || 0;
      
      // Modify your API call to include pagination parameters
      const response = await getChatsByProjectId(projectInfo._id, nextPage, messagePageSize);
      const oldMessages = response.data.messages.map(formatMessage);
      
      if (oldMessages.length > 0) {
        setFetchingOldMsg(true)
        setMessages(prev => [ ...prev, ...oldMessages]);
        setPage(nextPage);
        setHasMore(response.data.pagination.hasMore);
        
        // Adjust scroll position after new messages are added
        setTimeout(() => {
          if (messagesAreaRef.current) {
            const newScrollHeight = messagesAreaRef.current.scrollHeight;
            const heightDifference = newScrollHeight - scrollHeightBefore;
            messagesAreaRef.current.scrollTop = scrollTopBefore + heightDifference;
          }
        }, 0);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error loading more messages:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatMessage = (backendMessage) => {
    // console.log('userInfo._id', userInfo._id);
    // console.log('sender message', backendMessage.userId._id);
    if (userInfo._id == backendMessage.userId._id) {
      setUserInfo({ ...userDetails, profilePicture: backendMessage.userId?.profilePicture });
    }
    return {
      id: backendMessage._id,
      sender: `${backendMessage.userId.firstName} ${backendMessage.userId.lastName}`,
      avatar: backendMessage.userId.profilePicture || backendMessage?.userId?.linkedinProfilePic || "",
      message: backendMessage.text,
      timestamp: new Date(backendMessage.createdAt),
      displayTime: new Date(backendMessage.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      isOwn: backendMessage.userId._id == userInfo._id,
      attachments: backendMessage.attachmentsDownloadIds
    };
  };

  // const sendMessage = () => {
  //   if (!newMessage.trim()) return;
    
  //   console.log('userInfo', userInfo);
  //   socket.emit("sendMessage", { 
  //     projectId: projectInfo._id, 
  //     sender: userInfo, 
  //     text: newMessage, 
  //     channelId: projectInfo.slackChannelId,
  //     mentionedUsers: mentionedUsers,
  //   });
  //   setNewMessage("");
  // };

  const sendMessage = () => {
    // console.log('editor.getHTML()', editor.getHTML())
    const html = editor.getHTML()
    // if (html.trim() === '<p></p>') return
    if (html.trim() === '<p></p>' && (!attachedFiles || attachedFiles.length === 0)) {
      return;
    }

    setIsSendingMessage(true);

    const json = editor.getJSON();
    
    const mentionedUserIds = [];

    let allFileInfos = [];
    if(attachedFiles && attachedFiles.length > 0){
      allFileInfos = attachedFiles.map(file => file.fileInfo);
    }

    json.content?.forEach(block => {
      block.content?.forEach(node => {
        if (node.type === 'mention' && node.attrs?.id) {
          mentionedUserIds.push(node.attrs.id);
        }
      });
    });

    // console.log('Mentioned User IDs:', mentionedUserIds);

    // Step 3: Find full user data
    // const mentionedUsers = projectUsers.filter(user => mentionedUserIds.includes(user._id));
    let mentionedUsers;

    if (mentionedUserIds.includes(1)) {
      // mentionedUsers = projectUsers;
      mentionedUsers = projectUsers.filter(user => user._id !== 1);
    } else {
      // Else, filter normally
      mentionedUsers = projectUsers.filter(user => mentionedUserIds.includes(user._id));
    }

    // console.log('Mentioned Users Full Info:', mentionedUsers);

    // Step 4: Now you have:
    // console.log('Send this HTML:', html);
    // console.log('Mentioned Users:', mentionedUsers);
    
    socket.emit("sendMessage", { 
      projectId: projectInfo._id, 
      sender: userInfo,
      text: html, 
      channelId: projectInfo.slackChannelId,
      mentionedUsers: mentionedUsers,
      attachments: allFileInfos
    });

    // Clear after sending
    editor.commands.clearContent()
    setAttachedFiles([]);
  }
  const handleSendMessage = () => {
    sendMessage();
  };

  // Group messages by date
  const groupMessagesByDate = (msgs) => {
    const groups = {};
    msgs.slice().reverse().forEach(msg => {
      const date = new Date(msg.timestamp);
      const dateString = date.toDateString();
      
      if (!groups[dateString]) {
        groups[dateString] = [];
      }
      
      groups[dateString].push(msg);
    });

    const sortedGroups = Object.keys(groups)
    .sort((a, b) => new Date(a) - new Date(b))
    .reduce((acc, key) => {
      acc[key] = groups[key];
      return acc;
    }, {});
    
    return sortedGroups;
  };

  // Format date for display
  const formatDateLabel = (dateString) => {
    const today = new Date().toDateString();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayString = yesterday.toDateString();
    
    if (dateString === today) {
      return "Today";
    } else if (dateString === yesterdayString) {
      return "Yesterday";
    } else {
      return new Date(dateString).toLocaleDateString(undefined, { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    }
  };

  // Grouped messages
  const groupedMessages = groupMessagesByDate(messages);
  
  // Function to handle mention suggestions
  const handleMentionQuery = (query) => {
    // Filter project users based on the query
    console.log('query', query)
    const filteredUsers = projectUsers.filter(user => 
      user.firstName.toLowerCase().includes(query.toLowerCase()) ||
      user.lastName.toLowerCase().includes(query.toLowerCase()) ||
      `${user.firstName} ${user.lastName}`.toLowerCase().includes(query.toLowerCase())
    );
    
    setMentionSuggestions(filteredUsers);
    
    // Open popover if there are suggestions
    if (filteredUsers.length > 0 && inputRef.current) {
      setMentionAnchorEl(inputRef.current);
    } else {
      setMentionAnchorEl(null);
    }
  };

  // Function to add a mention to the message
  const addMention = (user) => {
    // Replace the @mention with the full name
    console.log('user', user)
    setMentionedUsers((prev)=>{
      return [...prev, user]
    })
    const mentionText = `@${user.firstName} ${user.lastName}`;
    
    // Replace the current mention query with the full name
    console.log('newMessage', newMessage)
    const updatedMessage = newMessage.replace(/@\w*$/, mentionText);
    console.log('updatedMessage', updatedMessage)
    
    setNewMessage(updatedMessage);
    setMentionAnchorEl(null);
    setMentionSuggestions([]);
    setMentionQuery("");
  };

  // Modify the message input change handler
  const handleMessageChange = (e) => {
    const value = e.target.value;
    setNewMessage(value);
    
    // Check for mention trigger
    console.log('value', value);
    console.log('mentionedUsers', mentionedUsers);
    const mentionMatch = value.match(/@(\w*)$/);
    if (mentionMatch) {
      console.log('mentionMatch', mentionMatch)
      const query = mentionMatch[1];
      setMentionQuery(query);
      handleMentionQuery(query);
    } else {

      const mentions = extractMentions(value);
      console.log('mentions', mentions);
      updateMentionedUsers(mentions);
      
      setNewMessage(value);

      setMentionQuery("");
      setMentionSuggestions([]);
      setMentionAnchorEl(null);
    }
  };

  // Extract mentioned users from the message
  const extractMentions = (message) => {
    // Regex to find mentions in the format @FirstName LastName
    const mentionRegex = /@(\w+)\s+(\w+)/g;
    const matches = [...message.matchAll(mentionRegex)];
    
    return matches.map(match => {
      const fullName = `${match[1]} ${match[2]}`;
      return projectUsers.find(
        user => `${user.firstName} ${user.lastName}` === fullName
      );
    }).filter(Boolean); // Remove any undefined matches
  };

  // Update mentioned users list
  const updateMentionedUsers = (mentions) => {
    // Remove users who are no longer mentioned
    const updatedMentions = mentions.filter(mention => 
      mention && !mentionedUsers.some(existing => existing._id === mention._id)
    );

    console.log('updatedMentions', updatedMentions)
    
    // Add new mentions
    if (updatedMentions.length > 0) {
      console.log('update updatedMentions', updatedMentions)
      setMentionedUsers(prev => [...prev, ...updatedMentions]);
    }
    
    // Remove mentions that are no longer in the message
    setMentionedUsers(prev => 
      prev.filter(user => 
        mentions.some(mention => mention._id === user._id)
      )
    );
  };
  const handleSlackModel = ()=>{
    setOpenSlackModel(true);
  }

  const handleOauth = ()=>{
    console.log('projectInfo.orgId', projectInfo);
    const state = btoa(JSON.stringify({userId:userInfo._id, returnUrl: `${process.env.REACT_APP_FRONTEND_URL}/org/${projectInfo?.orgId?._id}/project/view/${projectInfo._id}`}));
    window.location.href = `https://slack.com/oauth/v2/authorize?client_id=${process.env.REACT_APP_SLACK_CLIENT_ID}&user_scope=chat:write,channels:history,users:read&redirect_uri=${process.env.REACT_APP_SLACK_REDIRECT_URI}&state=${state}`
    // window.location.href = `https://slack.com/oauth/v2/authorize?client_id=${process.env.REACT_APP_SLACK_CLIENT_ID}&user_scope=chat:write,channels:history,users:read&redirect_uri=${process.env.REACT_APP_SLACK_REDIRECT_URI}&state=${{userId:userInfo._id, url: `${process.env.REACT_APP_FRONTEND_URL}/org/${projectInfo.orgId}/project/view/${projectInfo._id}`}}`
  }

  const editor = useEditor({
    extensions: [
      // StarterKit,
      StarterKit.configure({
        HTMLAttributes: {
          allowRawHTML: true,   // <<< ADD here
        },
      }),
      Image,
      // Underline,
      TiptapLink.configure({
        openOnClick: true,
        autolink: true,
        linkOnPaste: true,
      }),
      Mention.configure({
        HTMLAttributes: {
          class: 'mention',
        },
        suggestion: {
          char: '@',
          startOfLine: false,
          items: ({ query }) => {
            // Static list - Replace with your user search API later
            console.log('query', query)
            console.log('projectUsers', projectUsers)
            console.log('mentionSuggestions', mentionSuggestions)
            // const users = [
            //   { id: '1', label: 'john_doe' },
            //   { id: '2', label: 'jane_smith' },
            //   { id: '3', label: 'developer_guy' },
            // ]
            // return users.filter(user =>
            //   user.label.toLowerCase().includes(query.toLowerCase())
            // )
            // return projectUsers.filter(user => 
            //   user.firstName.toLowerCase().includes(query.toLowerCase()) ||
            //   user.lastName.toLowerCase().includes(query.toLowerCase()) ||
            //   `${user.firstName} ${user.lastName}`.toLowerCase().includes(query.toLowerCase())
            // );

            if (query === 'all') {
              return [
                // Optionally add other suggestions as needed (e.g., filtered users)
                ...projectUsers.map(user => {
                  if(user._id === 1) return {
                    id: user._id,
                    label: `${user.label}`,
                  };

                  return {
                    id: user._id,
                    label: `${user.firstName} ${user.lastName}`,
                  }
                }),
              ];
            }

            const existingMentions = [];
            editor.state.doc.descendants((node) => {
              console.log('node mention', node)
              if (node.type.name === 'mention') {
                existingMentions.push(node.attrs.id);
              }
            });

            return projectUsers
              .filter(user => {
                if (user._id === 1) {
                  // Special handling for user with _id === 1
                  return true; // Always include this user (or add custom logic)
                }
                return (
                  !existingMentions.includes(user._id) && (
                  user.firstName.toLowerCase().includes(query.toLowerCase()) ||
                  user.lastName.toLowerCase().includes(query.toLowerCase()) ||
                  `${user.firstName} ${user.lastName}`.toLowerCase().includes(query.toLowerCase())
                )
              )
            });
          },
          render: () => {
            let component
            let popup
  
            return {
              onStart: props => {
                component = document.createElement('div')
                component.style.background = '#333'
                component.style.padding = '8px'
                component.style.borderRadius = '8px'
                component.style.color = '#fff'
                component.style.fontSize = '14px'
                component.style.maxHeight = '150px'
                component.style.overflowY = 'auto'
  
                props.items.forEach(item => {
                  const option = document.createElement('div')
                  option.style.padding = '4px'
                  option.style.cursor = 'pointer'
                  // option.innerText = item.label
                  console.log('item in on start', item )
                  if(item._id === 1) {
                    option.innerHTML = `
                      <div><strong>${item.label}</strong></div>
                    `
                  } else {
                    option.innerHTML = `
                      <div><strong>${item.firstName} ${item.lastName}</strong></div>
                      <div style="font-size:12px; color:#aaa;">${item.email}</div>
                    `
                  }
                  option.onclick = () => {
                    // props.command({ id: item._id, label: `${item.firstName} ${item.lastName}` })
                    props.command({
                      id: item._id,
                      // label: `${item.firstName} ${item.lastName}`,
                      // email: item.email,
                      label: item._id == 1 ? item.label : `${item.firstName} ${item.lastName}`,
                      email: item._id == 1 ? '': item.email,
                    })
                  }
                  component.append(option)
                })
  
                document.body.appendChild(component)
                popup = component
                popup.style.position = 'absolute'
                popup.style.top = `${props.clientRect().top - 150}px`
                popup.style.left = `${props.clientRect().left}px`
                // popup.style.left = `${props.clientRect.left}px`;
                // popup.style.top = `${props.clientRect.top - popup.offsetHeight - 300}px`;
              },
              onUpdate: props => {
                while (popup.firstChild) {
                  popup.removeChild(popup.firstChild)
                }
                props.items.forEach(item => {
                  const option = document.createElement('div')
                  option.style.padding = '4px'
                  option.style.cursor = 'pointer'
                  console.log('item in on update', item )
                  // option.innerText = item.label
                  // option.onclick = () => {
                  //   props.command({ id: item.id, label: item.label })
                  // }
                  // option.innerHTML = `
                  //   <div><strong>${item.firstName} ${item.lastName}</strong></div>
                  //   <div style="font-size:12px; color:#aaa;">${item.email}</div>
                  // `
                  if(item._id === 1) {
                    option.innerHTML = `
                      <div><strong>${item.label}</strong></div>
                    `
                  } else {
                    option.innerHTML = `
                      <div><strong>${item.firstName} ${item.lastName}</strong></div>
                      <div style="font-size:12px; color:#aaa;">${item.email}</div>
                    `
                  }

                  option.onclick = () => {
                    props.command({
                      id: item._id,
                      label: item._id == 1 ? item.label : `${item.firstName} ${item.lastName}`,
                      email: item._id == 1 ? '': item.email,
                    })
                  }
                  popup.append(option)
                })
              },
              onExit: () => {
                if (popup) {
                  popup.remove()
                }
              },
            }
          },
        },
      })
    ],
    content: '',
    editorProps: {
      attributes: {
        class: 'editor-content',
      },
    },
  })

  const addLink = () => {
    if (linkUrl && linkText) {
      editor
        ?.chain()
        .focus()
        .insertContent(`<a href="${linkUrl}" target="_blank">${linkText}</a> <br/>`)
        .run()
    }
    setShowLinkModal(false)
    setLinkUrl('')
    setLinkText('')
  }

  // const openMentionList = () => {
  //   if (!editor) return;
  
  //   editor.commands.focus(); // focus the editor
  
  //   // Now manually trigger the mention suggestion
  //   const event = new KeyboardEvent('keydown', { key: '@' });
  //   document.dispatchEvent(event);
  // };

  const openMentionList = () => {
    if (!editor) return;
  
    editor.chain().focus().insertContent('@').run();
  };

  const handleAttachment = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
  
    const fileType = file.type;
    const fileName = file.name;
  
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileUrl = e.target.result;
  
      if (fileType.startsWith('image/')) {
        editor?.chain().focus().setImage({ src: fileUrl, alt: fileName }).run();
      } 
      else if (fileType.startsWith('video/')) {
        editor?.chain().focus().insertContent({
          type: 'video',
          attrs: {
            src: fileUrl,
            controls: true,
          },
        }).run();
      } 
      else {
        editor?.chain().focus().insertContent({
          type: 'paragraph',
          content: [
            {
              type: 'image',
              attrs: {
                src: '/dummy-file-icon.png',
                alt: 'file',
                style: 'width: 40px; height: 40px; display: inline-block;',
              },
            },
            {
              type: 'text',
              text: ` ${fileName}`,
            },
          ],
        }).run();
      }
    };
  
    reader.readAsDataURL(file);
  };
  
const handleFileChange = async (e) => {
  const files = Array.from(e.target.files);
  for (const file of files) {

    const fileId = Date.now() + Math.random().toString(36).substring(2, 9);

    const newFile = {
      id: fileId,
      file,
      type: file.type,
      progress: 0,
      uploading: true,
      serverPath: '',
    };
    setIsUploadingFile(true);

    setAttachedFiles(prev => [...prev, newFile]);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userInfo._id);
    formData.append('sessionId', socket.id);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/chat/upload`, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          setAttachedFiles(prev => prev.map(f => {
            if (f.id === fileId) {
              return { ...f, progress: percent };
            }
            return f;
          }));
        }
      });

      const fileUrl = response.data.fileUrl;
      
      // console.log('response', response.data);

      setAttachedFiles(prev => prev.map(f => {
        if (f.id === fileId) {
          return { ...f, uploading: false, serverPath: fileUrl, fileInfo: response.data };
        }
        return f;
      }));
      setIsUploadingFile(false);
    } catch (error) {
      console.error('Upload failed', error);
      setIsUploadingFile(false);
      // Optionally: remove the file from list if upload fails
    }
  }
};
  const removeFile = async (index) => {
    const fileToRemove = attachedFiles[index];

    // console.log('fileToRemove', fileToRemove);
    if (fileToRemove && fileToRemove?.fileInfo && fileToRemove?.fileInfo?.fileUrl) {
      try {
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/chat/file/delete/${fileToRemove?.fileInfo?._id}`);
        // console.log('response', response);

        setAttachedFiles(prev => prev.filter((_, i) => i !== index));
      } catch (error) {
        console.error('Failed to delete file from server', error);
      }
    }
  };

  const handleSend = () => {
    const textContent = editor?.getHTML();
    // console.log('Message:', textContent);
    // console.log('Files:', attachedFiles);

    // clear everything after sending
    editor?.commands.clearContent();
    setAttachedFiles([]);
  };

  const getFileIcon = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
  
    switch (ext) {
      case 'pdf':
        return pdf;
      case 'zip':
      case 'rar':
        return zip;
      case 'doc':
      case 'docx':
        return docx;
      case 'txt':
        return docx;
      case 'xls':
      case 'xlsx':
        return excel;
      default:
        return folder1;
    }
  };

  // Before user leaves the page
  window.addEventListener('beforeunload', (e) => {
    if (attachedFiles.size > 0) {

      let hasUploading = false;
      attachedFiles.forEach(file => {
        if (file.uploading) hasUploading = true;
      });
      
      if (hasUploading) {
        const message = 'You have uploads in progress. Are you sure you want to leave?';
        e.returnValue = message;
        return message;
      }
    }
  });

  // Helper to check file type
const getFileType = (url) => {
  const extension = url.split('.').pop().toLowerCase();
  console.log('extension', extension)
  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) return 'image';
  if (['mp4', 'webm', 'ogg', 'mov'].includes(extension)) return 'video';
  if (['mp3', 'wav', 'aac', 'flac', 'm4a', 'oga', 'opus'].includes(extension)) return 'audio';
  return 'file';
};

const handleFilesDownload = async (e, fileId) => {
  e.stopPropagation();
  try {
    const file = await downloadFileFromBox(fileId);
    console.log('file', file)
    if (file?.data) {
      // Step 2: Create a temporary <a> tag to trigger download
      const link = document.createElement('a');
      link.href = file?.data;
      link.download = ''; // Optional: specify filename
      link.target = '_blank'; // optional, for opening in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('File URL not found');
    }
  } catch (error) {
    console.error("Failed to get download URL", error);
    alert("Error downloading file. Please try again.");
  }
}
  
  return (
    <Box>
      <Paper
        sx={{
          height: "100%",
          border: "1px solid gray",
          borderRadius: 2,
          boxShadow: 2,
          overflowY: "auto",
        }}
      >
        <Stack direction="row" justifyContent="space-between">
          {/* <Typography variant="h6" fontWeight="bold" sx={{ padding: 2 }}>
            Chat
          </Typography> */}
          <Box sx={{ padding: "11px 0px 11px 16px" }}>
            <img
              src={slackIcon}
              alt="Slack icon"
              style={{ width: "30px", height: "auto" }}
            />
          </Box>
          <div style={{ display: "flex", marginRight: "10px" }}>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              slotProps={{
                paper: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: "20ch",
                    overflowX: "hidden",
                    left: "auto !important",
                  },
                },
              }}
              elevation={0}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              {/* {options.map((option) => (
                <MenuItem
                  key={option}
                  onClick={handleClose}
                >
                  {option}
                </MenuItem>
              ))} */}
              {userInfo?.isSlackWorkspaceJoined &&
              userInfo?.isSlackOauthCompleted ? (
                <MenuItem>
                  <Typography>Slack Connected</Typography>
                </MenuItem>
              ) : (
                <MenuItem onClick={handleSlackModel}>
                  {/* <a
                      href={`https://slack.com/oauth/v2/authorize?client_id=${process.env.REACT_APP_SLACK_CLIENT_ID}&user_scope=chat:write,channels:history,users:read&redirect_uri=${process.env.REACT_APP_SLACK_REDIRECT_URI}&state=${userInfo._id}`}
                    > */}
                  {/* <a href={`https://slack.com/oauth/v2/authorize?client_id=${process.env.REACT_APP_SLACK_CLIENT_ID}&scope=chat:write,users:read&redirect_uri=${process.env.REACT_APP_SLACK_REDIRECT_URI}&userId=${userInfo._id}`}> */}
                  {/* <button>Connect with Slack</button> */}
                  {/* Connect with Slack
                    </a> */}
                  <a>Connect with Slack </a>
                </MenuItem>
              )}
            </Menu>
          </div>
        </Stack>
        <Box>
          <Divider />
        </Box>

        <ChatContainer>
          <MessagesArea ref={messagesAreaRef}>
            {/* Loading indicator at the top when fetching older messages */}
            {loading && (
              <LoaderContainer>
                <CircularProgress size={24} />
              </LoaderContainer>
            )}

            {/* Render messages grouped by date */}
            {Object.entries(groupedMessages).map(([dateString, msgs]) => (
              <Box key={dateString}>
                <DateDivider>
                  <DateLine />
                  <DateLabel>{formatDateLabel(dateString)}</DateLabel>
                  <DateLine />
                </DateDivider>

                {msgs.map((msg) => (
                  <Box
                    key={msg.id}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: msg.isOwn ? "flex-end" : "flex-start",
                      mb: 2,
                    }}
                  >
                    <Stack
                      direction={msg.isOwn ? "row-reverse" : "row"}
                      spacing={1}
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <Avatar
                        src={`${msg.avatar}`}
                        alt={msg.sender}
                        sx={{ width: 32, height: 32 }}
                      />
                      <Typography variant="subtitle2" color="text.secondary">
                        {msg.sender}
                      </Typography>
                    </Stack>

                    {
                      msg.message != '<p></p>' &&
                      <MessageBubble isOwn={msg.isOwn}>
                        <Typography
                          component="div"
                          className="message-text"
                          dangerouslySetInnerHTML={{ __html: msg.message }}
                          sx={{
                            wordBreak: "break-word",
                            "& p": {
                              margin: 0,
                            },
                            "& strong": {
                              fontWeight: "bold",
                            },
                            "& a": {
                              color: "#0077FF",
                              textDecoration: "underline",
                            },
                            fontSize: "14px",
                            lineHeight: 1.4,
                          }}
                        >
                          {/* {msg.message} */}
                        </Typography>
                        <Typography
                          variant="caption"
                          color={
                            msg.isOwn ? "rgba(0, 0, 0, 0.7)" : "text.secondary"
                          }
                        >
                          {msg.displayTime}
                        </Typography>
                      </MessageBubble>
                    }

                    {/* attachments show */} 
                    <Box display="flex" justifyContent={msg.isOwn ? 'end': 'start'} flexWrap="wrap" gap={2} mb={1.7} mt={1}>
                      {msg?.attachments?.length > 0 &&
                        msg.attachments.map((attachment, index) => {
                          const { downloadUrl, fileId, fileDetail, originalName } = attachment;
                          const fileType = getFileType(fileDetail.name);

                          return (
                            <Box key={fileId || index} sx={{ display: "block" }}>
                              <Box
                                sx={{
                                  width: { md: 250, lg: 350 },
                                  // height: fileType== 'audio'? 'auto' :200,
                                  borderRadius: 3,
                                  overflow: "hidden",
                                  // boxShadow: 3,
                                  position: "relative",
                                  backgroundColor: "#f9f9f9",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: "1px solid #d7d7d7",
                                  "&:hover .download-icon": {
                                    opacity: 1,
                                  },
                                  "&:hover": {
                                    // boxShadow: 6,
                                    transform: "scale(1.02)",
                                    transition: "0.3s",
                                  },
                                }}
                              >
                                {/* --- Download Icon Overlay --- */}
                                <IconButton
                                  className="download-icon"
                                  onClick={async (e) => {
                                    handleFilesDownload(e, fileId)
                                  }}
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                    color: "white",
                                    opacity: 0,
                                    transition: "opacity 0.3s",
                                    zIndex: 9999,
                                    "&:hover": {
                                      backgroundColor: "rgba(0,0,0,0.7)",
                                    },
                                  }}
                                >
                                  <CloudDownloadIcon />
                                </IconButton>

                                {/* --- File Previews --- */}
                                {fileType === "image" ? (
                                  <Box
                                    component="img"
                                    src={downloadUrl}
                                    alt="Image"
                                    sx={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                      maxHeight: '250px'
                                      // padding: "7px",
                                    }}
                                  />
                                ) : fileType === "video" ? (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      height: "100%",
                                      position: "relative",
                                      marginBottom: '-7px'
                                    }}
                                  >
                                    <Box
                                      component="video"
                                      src={downloadUrl}
                                      controls
                                      sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </Box>
                                ) : fileType === "audio" ? (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      height: '125px',
                                      display: "flex",
                                      alignItems: "end",
                                      justifyContent: "center",
                                      padding: 2,
                                    }}
                                  >
                                    <audio controls>
                                      <source src={downloadUrl} type="audio/mpeg" />
                                      Your browser does not support the audio element.
                                    </audio>
                                  </Box>
                                ) : (
                                  <Box textAlign="center" p={2}>
                                    <InsertDriveFileIcon
                                      sx={{
                                        fontSize: 50,
                                        color: "primary.main",
                                        mb: 1,
                                      }}
                                    />
                                    <Typography variant="body2" noWrap>
                                      {/* {fileDetail.name} */}
                                      {originalName}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>

                              <Typography
                                mt={1}
                                textAlign={msg.isOwn? "end": 'start'}
                                variant="h6"
                                color={msg.isOwn ? "rgba(0, 0, 0, 0.7)" : "text.secondary"}
                              >
                                {msg.displayTime}
                              </Typography>
                            </Box>
                          );
                        })}
                    </Box>
                    
                  </Box>
                ))}
              </Box>
            ))}
          </MessagesArea>

          {/* Chat input editor */}
          <Box
            sx={{
              backgroundColor: "#fff  ",
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              padding: "0px 8px",
              color: "#000",
              position: "relative",
              pt: "8px",
            }}
          >
            {/* Top Toolbar */}
            {showToolbar && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton
                  onClick={() => editor?.chain().focus().toggleBold().run()}
                >
                  <FormatBoldIcon />
                </IconButton>
                <IconButton
                  onClick={() => editor?.chain().focus().toggleItalic().run()}
                >
                  <FormatItalicIcon />
                </IconButton>
                {/* <IconButton onClick={() => editor?.chain().focus().toggleUnderline().run()}><FormatUnderlinedIcon sx={{ color: '#fff' }} /></IconButton> */}
                <IconButton onClick={() => setShowLinkModal(true)}>
                  <InsertLinkIcon />
                </IconButton>
                <IconButton
                  onClick={() =>
                    editor?.chain().focus().toggleOrderedList().run()
                  }
                >
                  <FormatListNumberedIcon />
                </IconButton>
                <IconButton
                  onClick={() =>
                    editor?.chain().focus().toggleBulletList().run()
                  }
                >
                  <FormatListBulletedIcon />
                </IconButton>
              </Box>
            )}

            {/* Middle Editor */}
            <Box
              className="editor-chat"
              sx={{
                minHeight: "66px",
                backgroundColor: "#ededed",
                borderRadius: 1,
                p: 1,
                fontSize: 14,
              }}
            >
              <EditorContent
                editor={editor}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && !event.shiftKey) {
                    const isInList =
                      editor.isActive("bulletList") ||
                      editor.isActive("orderedList");

                    if (!isInList) {
                      event.preventDefault();
                      sendMessage();
                      // handleSend()
                    }
                  }
                }}
              />
              <Box>
                {/* {attachedFiles.length > 0 && (
                <div className="files-div file-preview-container">
                  {attachedFiles.map((item, index) => (
                    <div key={index} style={{ position: 'relative', marginRight: '8px', marginBottom: '8px' }}>
                      {item.type.startsWith('image') && (
                        <img src={item.preview} alt="preview" className="preview-dummy" />
                      )}
                      {item.type.startsWith('video') && (
                        <video controls className="preview-video">
                          <source src={item.preview} type={item.type} />
                          Your browser does not support video.
                        </video>
                      )}
                      {!item.type.startsWith('image') && !item.type.startsWith('video') && (
                        <img src={getFileIcon(item.file.name)} alt="file" className="preview-image"/>
                      )}
                      <button
                        onClick={() => removeFile(index)}
                        className="remove-btn"
                      >
                        ✖
                      </button>
                    </div>
                  ))}
                </div>
              )} */}

                {attachedFiles.length > 0 && (
                  <div className="files-div file-preview-container">
                    {attachedFiles.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          marginRight: "8px",
                          marginBottom: "8px",
                        }}
                      >
                        {item.type.startsWith("image") && (
                          // <img src={item.serverPath ? item.serverPath:item.preview} alt="preview" className="preview-dummy" />
                          <img
                            src={item.serverPath}
                            alt="preview"
                            className="preview-dummy"
                          />
                        )}
                        {item.type.startsWith("video") && (
                          <video controls className="preview-video">
                            {/* <source src={item.serverPath ? item.serverPath:item.preview} type={item.type} /> */}
                            <source src={item.serverPath} type={item.type} />
                            Your browser does not support video.
                          </video>
                        )}
                        {item.type.startsWith("audio") && item.serverPath && (
                          <audio controls className="preview-audio">
                            <source src={item.serverPath} type={item.type} />
                            Your browser does not support the audio element.
                          </audio>
                        )}
                        {!item.type.startsWith("image") &&
                          !item.type.startsWith("video") &&
                          !item.type.startsWith("audio") && (
                            <img
                              src={getFileIcon(item.file.name)}
                              alt="file"
                              className="preview-image"
                            />
                          )}

                        {/* Progress Bar */}
                        {item.uploading && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: 0,
                              left: 0,
                              right: 0,
                              height: "4px",
                              backgroundColor: "#eee",
                            }}
                          >
                            <div
                              style={{
                                width: `${item.progress}%`,
                                height: "100%",
                                backgroundColor: "#4caf50",
                                transition: "width 0.3s",
                              }}
                            />
                          </div>
                        )}

                        <button
                          onClick={() => removeFile(index)}
                          className="remove-btn"
                          disabled={item.uploading} // Disable remove button while uploading
                        >
                          ✖
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </Box>
              {/* <IconButton
                size="small"
                sx={{
                  position: "absolute",
                  right: 8,
                  bottom: 8,
                  backgroundColor: "#ccc",
                  width: '50px',
                  height: 30,
                  borderRadius: "0%",
                }}
                onClick={handleSend}
                // onClick={sendMessage}
              >
                <SendIcon fontSize="small" />
              </IconButton> */}
              <IconButton
                size="small"
                sx={{
                  position: "absolute",
                  right: 8,
                  bottom: 8,
                  backgroundColor: "#ccc",
                  width: "50px",
                  height: 30,
                  borderRadius: "0%",
                }}
                onClick={sendMessage}
                // onClick={handleSend}
                disabled={attachedFiles.some((file) => file.uploading) || isSendingMessage }
              >
                {/* <SendIcon fontSize="small" /> */}
                {isSendingMessage ? (
                  <CircularProgress size={16} sx={{ color: "black" }} />
                ) : (
                  <SendIcon fontSize="small" />
                )}
              </IconButton>
            </Box>

            {/* Bottom Toolbar */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton onClick={() => setShowToolbar(!showToolbar)}>
                {showToolbar ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>

              <IconButton onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                <EmojiEmotionsIcon />
              </IconButton>

              <IconButton onClick={() => openMentionList()}>
                <AlternateEmailIcon />
              </IconButton>

              {/* Attachment Button */}
              <IconButton component="label">
                <AttachFileIcon />
                <input
                  type="file"
                  hidden
                  multiple
                  onChange={handleFileChange}
                />
              </IconButton>

              {/* You can add Video / Mic / Edit icons similarly */}
            </Box>

            {/* Emoji Picker */}
            {showEmojiPicker && (
              <Box sx={{ position: "absolute", bottom: 90 }}>
                <EmojiPicker
                  onEmojiClick={(emojiData) => {
                    editor
                      ?.chain()
                      .focus()
                      .insertContent(emojiData.emoji)
                      .run();
                    setShowEmojiPicker(false);
                  }}
                />
              </Box>
            )}

            {/* Link Modal */}
            <Modal open={showLinkModal} onClose={() => setShowLinkModal(false)}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: 2,
                  width: "40%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <TextField
                  label="Link Text"
                  value={linkText}
                  onChange={(e) => setLinkText(e.target.value)}
                />
                <TextField
                  label="Link URL"
                  value={linkUrl}
                  onChange={(e) => setLinkUrl(e.target.value)}
                />
                <Button variant="contained" onClick={addLink}>
                  Add Link
                </Button>
              </Box>
            </Modal>
          </Box>

        </ChatContainer>
      </Paper>

      <Modal
        open={openSlackModel}
        onClose={() => {
          setOpenSlackModel(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {userInfo?.isSlackWorkspaceJoined ? (
          <Box sx={style}>
            <Box mb={1}>
              <Typography variant={"h3"}>Connect With Slack</Typography>
            </Box>
            <Divider />

            <Box mt={2}>
              <Box mb={2}>
                <Typography variant="h5" sx={{ mb: 2 }}>
                  To proceed, please connect your Slack account by authorizing
                  access.
                </Typography>
              </Box>
              <Stack direction="row" gap="10px" justifyContent="end">
                <Button
                  onClick={() => {
                    setOpenSlackModel(false);
                  }}
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  onClick={handleOauth}
                >
                  Connect
                </Button>
              </Stack>
            </Box>
          </Box>
        ) : (
          <Box sx={style}>
            <Box mb={1}>
              <Typography variant={"h3"}>Join Slack Workspace</Typography>
            </Box>
            <Divider />

            <Box mt={2}>
              <form onSubmit={formik.handleSubmit}>
                <Box mb={2}>
                  <Typography variant="h5" sx={{ mb: 2 }}>
                    Before connecting Slack, you need to join our workspace.
                  </Typography>
                  <Typography variant="h5" sx={{ mb: 2 }}>
                    please enter the email address you used for Slack. This
                    ensures a smooth connection between your account and Slack.
                  </Typography>
                  <TextField
                    fullWidth
                    label="Enter your Slack email address"
                    variant="outlined"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                    margin="dense"
                  />
                </Box>
                <Stack direction="row" gap="10px" justifyContent="end">
                  <Button
                    onClick={() => {
                      setOpenSlackModel(false);
                    }}
                    color="secondary"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    disabled={!formik.isValid || !formik.dirty}
                  >
                    Submit
                  </Button>
                </Stack>
              </form>
            </Box>
          </Box>
        )}
      </Modal>
    </Box>
  );
};

